module.exports = new __parcel__URL__("blob_room_door.ff33612c.png").toString();